import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bb34196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loop-scroll-title" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = { class: "slide-item" }

import { onMounted, ref } from 'vue';
import { Autoplay } from 'swiper/modules';
import SwiperComponent from 'swiper';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const swiperRef = ref<HTMLDivElement>();

const titles = [
  '#원더플캠페인',
  '#보틀투보틀',
  '#재생페트병'
];

onMounted(() => {
  new SwiperComponent(swiperRef.value!, {
    slidesPerView: 9,
    slidesPerGroup: 2, // 调大（快）会卡
    loop: true,
    speed: 3000, // 调小（快）会卡
    spaceBetween: 0,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false
    },
    modules: [Autoplay],
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "swiperRef",
      ref: swiperRef,
      class: "swiper"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(titles, (title) => {
              return _createElementVNode("div", {
                key: title,
                class: "swiper-slide"
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(title), 1)
              ])
            }), 64))
          ], 64))
        }), 64))
      ])
    ], 512)
  ]))
}
}

})